import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { SecurityService } from '@app/services/security.service';
import { Constants } from '@app/common/constants';
import { AuthService } from '@app/services/auth.service';
//import { navigationCancelingError } from '@angular/router/src/shared';
import { Roles } from '@app/common/roles';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {

  //constructor(private authService: AuthService) { }
  constructor(private securityService: SecurityService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      return this.securityService.hasUserPdpRole(Constants.PDP_ROLE_ADMIN);

    // const roles = this.authService.idTokenClaims.get('roles') as Array<string>;
    // if (!roles || roles.length === 0) {
    //   //throw navigationCancelingError('unauthenticated');
    // } else {
    //   return roles.some(role => role === Roles[Roles.Admin]);
    // }
  }
}
